// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"5cb5a546","859":"eaa6c1f1"}[chunkId] + ".chunk.js";
};